import { gql } from '@apollo/client';
import { ProductPricesFragment } from '@core-frontend/fragments/ProductPricesFragment';

export const filterProductsQuery = gql`
  ${ProductPricesFragment}
  query filterProducts($filters: FilterInput, $limit: Int, $skipFirst: Int) {
    filterProducts(filters: $filters, limit: $limit, skipFirst: $skipFirst) {
      productCount
      products {
        available
        brand
        brandName
        brandUri
        categories {
          category
          name
          uri
        }
        category
        categoryName
        categoryUri
        discountPercent
        name
        metaTitle
        metaDescription
        variantName
        price
        swatch {
          hex
          desc
        }
        isShopTheLook: shop_the_look_text
        priceAsNumber
        ...ProductPrices
        isRaffle: raffle_text
        google_merchant_color
        measurementChart {
          unit
          contents {
            x
            y
            content
          }
          x
          y
        }
        priceBeforeDiscount
        priceBeforeDiscountAsNumber
        product
        showAsNew
        showAsOnSale
        uri
        sku
        product_material
        sustainability {
          id
          label
        }
        items {
          item
          ean
          itemTableY
          itemTableX
          name
          sku
          stock
        }
        media {
          blur
          thumb
          standard
          full
          big
          new_thumb
          new_small
          new_small_x2
          new_medium
          new_medium_x2
          new_standard
          new_standard_x2
          new_big
          new_big_x2
        }
        fit: pr_fit
      }
    }
  }
`;
